//#region RAYCAST
import $ from "jquery";
import * as THREE from "three";
import { camera, renderer } from "./3d-scene";
import { state } from "./settings";
import { lastScreenForRemove, showAvailableSpansScreen } from "./customFunctions/subSystemScreen";
import {
  lastHeatersForRemove, showAvailableSpans,
  updateHotspots,
  hotspots
} from "./customFunctions/subSystemHeaters";

export const raycastItem = [];
export const objectForRaycast = [];

export function initRaycast() {
  const raycaster = new THREE.Raycaster();
  const mouse = new THREE.Vector2();
  const canvas = document.getElementById("ar_model_view");
  let isMouseMoved = false;
  let clickThreshold = 5;
  let startX, startY;

  function onMouseDown(event) {
    isMouseMoved = false;
    startX = event.offsetX;
    startY = event.offsetY;
  }

  function onMouseMove(event) {
    mouse.x = (event.offsetX / renderer.domElement.clientWidth) * 2 - 1;
    mouse.y = -(event.offsetY / renderer.domElement.clientHeight) * 2 + 1;
    raycaster.setFromCamera(mouse, camera);

    const visibleClickableObjects =
      getVisibleClickableObjects(objectForRaycast);
    const intersects = raycaster.intersectObjects(
      visibleClickableObjects,
      true
    );

    if (intersects.length > 0) {
      canvas.style.cursor = "pointer";
    } else {
      canvas.style.cursor = "default";
    }

    if (
      Math.abs(event.offsetX - startX) > clickThreshold ||
      Math.abs(event.offsetY - startY) > clickThreshold
    ) {
      isMouseMoved = true;
    }
  }

  function onMouseUp(event) {
    if (!isMouseMoved) {
      event.stopPropagation();

      mouse.x = (event.offsetX / renderer.domElement.clientWidth) * 2 - 1;
      mouse.y = -(event.offsetY / renderer.domElement.clientHeight) * 2 + 1;
      raycaster.setFromCamera(mouse, camera);

      const visibleClickableObjects = getVisibleClickableObjects(objectForRaycast);
      const intersects = raycaster.intersectObjects(visibleClickableObjects, true);

      if (intersects.length > 0) {
        const intersectedObject = intersects[0].object;

        if (intersectedObject.name.includes("screen")) {
          lastScreenForRemove.last = intersectedObject.perentSpan;

          if (intersectedObject.perentSpan.isScreen) {
            state.portalOption = "screens";
            $(".portal-screen").show();
            $(".portal-shades").hide();
            $(".portal-heaters").hide();
            $(".portal-light").hide();

            $("#screen").addClass("sun__icon-active--screen");
            $(".interface-container").addClass("interface-container-portal");
            $("body").addClass("body-hidden");

            showAvailableSpansScreen("SC");
          }

          if (intersectedObject.perentSpan.isShades) {
            state.portalOption = "shades";
            $(".portal-shades").show();
            $(".portal-screen").hide();
            $(".portal-heaters").hide();
            $(".portal-light").hide();

            $("#shades").addClass("sun__icon-active--shades");
            $(".interface-container").addClass("interface-container-portal");
            $("body").addClass("body-hidden");

            showAvailableSpansScreen("SH");
          }
        } else {
          lastHeatersForRemove.last = intersectedObject.perentSpan;
          state.currentActiveSpans = state.currentActiveSpans.filter(
            (span) => span !== $(lastHeatersForRemove.last.hotspot.element).get(0).id
          );

          // Set heater mode
          state.currentSubSystem = "heaters";
          state.portalOption = "heaters";

          $(".portal-heaters").show();
          $(".portal-screen").hide();
          $(".portal-shades").hide();
          $(".portal-light").hide();

          $("#heaters").addClass("sun__icon-active--heaters");
          $(".interface-container").addClass("interface-container-portal");
          $("body").addClass("body-hidden");

          showAvailableSpans();
          updateHotspots(hotspots);
        }
      }
    }
  }

  canvas.addEventListener("mousedown", onMouseDown);
  canvas.addEventListener("mousemove", onMouseMove);
  canvas.addEventListener("mouseup", onMouseUp);
}

function getVisibleClickableObjects() {
  return raycastItem
    .filter((span) => span.isHeater || span.isScreen || span.isShades)
    .map((span) => span.avatar);
}

//#endregion
